import { css } from 'styled-components';

export default css`
  .hero-section {
    background-position: top;
  }
`;
